module.exports = __webpack_public_path__ + "static/media/SF-5-A (1).e5d05b0b.mp3";